<div class="warehouse-page core-screen">
  @if (loading()) {
  <div class="loading">
    <span>{{ 'common.loading' | translate }}</span>
  </div>
  } @else if (error()) {
  <div class="error">
    <span>{{ error() }}</span>
  </div>
  } @else if (warehouse(); as wh) {
  <div class="warehouse-content">
    <div class="warehouse-header">
      <div class="warehouse-icon">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M3 21V8l9-5 9 5v13"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9 21V12h6v9"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="warehouse-title">
        <h1 class="warehouse-name">{{ wh.name }}</h1>
        <div class="warehouse-status" [class.active]="wh.status === 'active'">
          {{ wh.status === 'active' ? ('warehouse.status.active' | translate) :
          ('warehouse.status.inactive' | translate) }}
        </div>
      </div>
      <button
        class="edit-button"
        (click)="onEdit()"
        [attr.aria-label]="'admin.warehouses.actions.edit' | translate"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    @if (stats(); as st) {
    <div class="stats-grid">
      <div class="stat-card stat-card--highlight">
        <span class="stat-value">{{ loadingPercentageLabel() }}%</span>
        <span class="stat-label"
          >{{ 'warehouse.stats.loadingPercentage' | translate }}</span
        >
      </div>
      <div class="stat-card">
        <span class="stat-value">{{ st.total_boxes }}</span>
        <span class="stat-label"
          >{{ 'warehouse.stats.totalBoxes' | translate }}</span
        >
      </div>
      <div class="stat-card">
        <span class="stat-value">{{ st.stored_boxes }}</span>
        <span class="stat-label"
          >{{ 'warehouse.stats.storedBoxes' | translate }}</span
        >
      </div>
      <div class="stat-card">
        <span class="stat-value">{{ st.in_transit }}</span>
        <span class="stat-label"
          >{{ 'warehouse.stats.inTransit' | translate }}</span
        >
      </div>
      <div class="stat-card">
        <span class="stat-value">{{ st.stored_units }}</span>
        <span class="stat-label"
          >{{ 'warehouse.stats.storedUnits' | translate }}</span
        >
      </div>
    </div>
    }

    @if (canOpenPlacement()) {
    <button type="button" class="placement-btn" (click)="openPlacement()">
      {{ 'admin.warehouses.openPlacement' | translate }}
    </button>
    }

    <div class="info-card">
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.address.city' | translate }}</span
        >
        <span class="info-value">{{ wh.city }}</span>
      </div>
      @if (wh.address) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.address.address' | translate }}</span
        >
        <span class="info-value">{{ wh.address }}</span>
      </div>
      } @if (wh.phone) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.address.phone' | translate }}</span
        >
        <span class="info-value">{{ wh.phone }}</span>
      </div>
      }
    </div>

    @if (wh.area_m2 || wh.height_m || wh.useful_volume_m3) {
    <div class="info-card">
      @if (wh.area_m2) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.characteristics.area' | translate }}</span
        >
        <span class="info-value"
          >{{ wh.area_m2 }} {{ 'warehouse.units.squaredMeters' | translate
          }}</span
        >
      </div>
      } @if (wh.height_m) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.characteristics.height' | translate }}</span
        >
        <span class="info-value"
          >{{ wh.height_m }} {{ 'warehouse.units.meters' | translate }}</span
        >
      </div>
      } @if (wh.useful_volume_m3) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.characteristics.volume' | translate }}</span
        >
        <span class="info-value"
          >{{ wh.useful_volume_m3 }} {{ 'warehouse.units.cubicMeters' |
          translate }}</span
        >
      </div>
      }
    </div>
    } @if (wh.has_heating !== undefined || wh.camera_count ||
    wh.leak_sensor_count) {
    <div class="info-card">
      @if (wh.has_heating !== undefined) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.equipment.heating' | translate }}</span
        >
        <span class="info-value"
          >{{ wh.has_heating ? ('common.yes' | translate) : ('common.no' |
          translate) }}</span
        >
      </div>
      } @if (wh.camera_count) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.equipment.cameras' | translate }}</span
        >
        <span class="info-value">{{ wh.camera_count }}</span>
      </div>
      } @if (wh.leak_sensor_count) {
      <div class="info-row">
        <span class="info-label"
          >{{ 'warehouse.equipment.leakSensors' | translate }}</span
        >
        <span class="info-value">{{ wh.leak_sensor_count }}</span>
      </div>
      }
    </div>
    } @if (wh.rows && wh.rows.length > 0) {
    <div class="rows-card">
      <div class="rows-header">
        <span class="rows-title"
          >{{ 'warehouse.rowsSection.title' | translate }}</span
        >
        <span class="total-cells">{{ totalCells() }}</span>
      </div>
      @for (row of wh.rows; track row.id) {
      <div class="row-item">
        <div class="row-main">
          <span class="row-label"
            >{{ 'warehouse.rowsSection.rowLabel' | translate }} {{
            row.row_number }}</span
          >
          <span class="row-cells">{{ row.floors * row.columns }}</span>
        </div>
        <div class="row-details">
          <span class="row-detail"
            >{{ 'warehouse.rowsSection.floorsPlaceholder' | translate }}: {{
            row.floors }}</span
          >
          <span class="row-detail"
            >{{ 'warehouse.rowsSection.columnsPlaceholder' | translate }}: {{
            row.columns }}</span
          >
        </div>
      </div>
      }
    </div>
    }

    @if (hasWarehouseGrid()) {
    <lib-staff-warehouse-cell-grid
      [warehouse]="wh"
      [cells]="cells()"
      [occupiedCellIds]="occupiedCellIds()"
      [loading]="cellsLoading()"
      [error]="cellsError()"
    />
    }

    <div class="info-card">
      <div class="toggle-row">
        <div class="toggle-info">
          <span class="toggle-label"
            >{{ 'admin.warehouses.activeStatus' | translate }}</span
          >
          <span class="toggle-description">
            {{ wh.status === 'active' ? ('admin.warehouses.activeDescription' |
            translate) : ('admin.warehouses.inactiveDescription' | translate) }}
          </span>
        </div>
        <label class="toggle-switch" [class.disabled]="isToggling()">
          <input
            type="checkbox"
            [checked]="wh.status === 'active'"
            (change)="onToggleActive($event)"
            [disabled]="isToggling()"
          />
          <span class="slider"></span>
        </label>
      </div>
    </div>
  </div>
  }
</div>
